import { jsx } from "react/jsx-runtime";
function TldrawUiButtonLabel({ children }) {
  return /* @__PURE__ */ jsx("span", { className: "tlui-button__label", children });
}
export {
  TldrawUiButtonLabel
};
//# sourceMappingURL=TldrawUiButtonLabel.mjs.map
